import * as $ from "jquery";

export class subMenuToggle {
	$scope: any = $(".enrich-money-header-wrapper");

	$list: any = $(".enrich-money-nav-list");

	$icon: any = $(
		".enrich-money-nav-list .enrich-money-list-item .list-item-container .down-arrow"
	);

	toggleSubmenu(): any {
		let _self = this;
		let $listItems = $(".enrich-money-nav-list .enrich-money-list-item");
		let count: any = 0;

		for (let item of $listItems) {
			$(item).attr("data-index", `id-${count}`);
			count += 1;
		}
		this.$icon.on("click", function () {
			let $listItems: any = $(".enrich-money-nav-list .enrich-money-list-item");

			$(this).toggleClass("rotate-icon");

			$(this).parent().siblings("ul").toggleClass("show");
			for (let item of $listItems) {
				if (
					$(item).attr("data-index") ===
					$(this).parent().parent().attr("data-index")
				) {
					continue;
				} else {
					$(item).children("ul").removeClass("show");
					$(item)
						.children(".list-item-container")
						.children("span")
						.removeClass("rotate-icon");
				}
			}
		});
	}
}

//

export class disableSubmenu {
	$scope: any = $(".enrich-money-header-wrapper");
	$list: any = $(".enrich-money-nav-list");
	$listItems: any = $(".enrich-money-nav-list .enrich-money-list-item");

	disableHandler(): any {
		for (let listItem of this.$listItems) {
			if ($(listItem).children("ul").length === 0) {
				
				$(listItem)
					.children(".list-item-container")
					.children("a")
					.addClass("full-size");
				$(listItem)
					.children(".list-item-container")
					.children("span")
					.addClass("removeIcon");
			}
		}
	}
}

export class navigateToMobileStores {
	$scope: any = $(".enrich-money-header-wrapper");
	$applyNowBtn = $(".header-btn");
	$applyNowLink: any = $(".enrichmoney-app-download-btn");

	downloadButtonClickHandler(): any {
		let $screenSize: any = $(window).width();
		let userAgent: any = navigator.userAgent || navigator.vendor;

		if ($screenSize < 768) {
			if (
				userAgent.match(/iPad/i) ||
				userAgent.match(/iPhone/i) ||
				userAgent.match(/iPod/i)
			) {
				let $iosAppStoreLink: any = this.$applyNowBtn.attr(
					"data-enrichmoney-download-ios"
				);
				this.$applyNowLink.attr("href", $iosAppStoreLink);
			} else if (userAgent.match(/Android/i)) {
				let $androidPlayStoreLink: any = this.$applyNowBtn.attr(
					"data-enrichmoney-download-android"
				);
				this.$applyNowLink.attr("href", $androidPlayStoreLink);
			}
		} else {
			if (
				userAgent.match(/iPad/i) ||
				userAgent.match(/iPhone/i) ||
				userAgent.match(/iPod/i)
			) {
				let $iosAppStoreLink: any = this.$applyNowBtn.attr(
					"data-enrichmoney-download-ios"
				);
				this.$applyNowLink.attr("href", $iosAppStoreLink);
			} else {
				let $androidPlayStoreLink: any = this.$applyNowBtn.attr(
					"data-enrichmoney-download-android"
				);
				this.$applyNowLink.attr("href", $androidPlayStoreLink);
			}
		}
	}
}

let scope: Element = document.querySelector(".enrich-money-header-wrapper");
let overlay: any = $("#overlay-container");

if (scope) {
	try {
		$(document).ready(function () {
			let toggleSubmenu = new subMenuToggle();
			let disableSubmenuHandler = new disableSubmenu();

			let navigateToStores = new navigateToMobileStores();
			toggleSubmenu.toggleSubmenu();
			disableSubmenuHandler.disableHandler();
			navigateToStores.downloadButtonClickHandler();

			$(".open").click(function () {
				$(this).css("display", "none");
				$(overlay).css({ "z-index": "100", background: "rgba(0,0,0, 0.2)" });
				// $(".close").css("display", "block");
				$("#menu").addClass("mobile-menu");
				$(".enrich-money").addClass("scroll-stop");
			});

			// $(".close").click(function () {
			// 	$(overlay).css({ "z-index": "-1", background: "none" });
			// 	$(this).css("display", "none");
			// 	$(".open").css("display", "block");
			// 	$("#menu").removeClass("mobile-menu");
			// 	$(".enrich-money").removeClass('scroll-stop')
			// });

			$(overlay).click(function () {
				// $('.close').css('display', 'none')
				$(".open").css("display", "block");
				$(this).css({ "z-index": "-1", background: "none" });
				$("#menu").removeClass("mobile-menu");
				$(".enrich-money").removeClass("scroll-stop");
			});
		});
	} catch (e) {
		console.error(e);
	}
}
